import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import i18n from 'src/i18n';

import withRouter from 'src/components/withRouter';
import withProfile from 'src/components/withProfile';
import AlertView from 'src/components/Alert';
import signInViewModel from 'src/components/Header/component/SignIn/viewModel';

import styles from './styles.module.scss';


@observer
class PurchaseModal extends React.Component {

  render() {
    const { viewModel, notice, profile, cid } = this.props;
    return (
      <AlertView
        vm={viewModel}
        className={styles.zIndex}
        showClose={false}
        showButtons={false}
        contentContainerStyles={styles.contentContainerStyles}
      >
        <div className={`regulation ${clsx(styles.purchaseAlert, styles.purchaseAlert_layout)}`}>
          <div className={clsx(styles.alertFlex, styles.alertFlex_layout)}>
            <div className={clsx(styles.alertFlex_item)}>
              <h3 className={clsx(styles.alertTitle, styles.alertTitle_layout)}>
                {i18n.t('modal_purchase')}
              </h3>
            </div>

            <div className={clsx(styles.alertContent, styles.alertContent_layout)}>
              <div className={clsx(styles.contentContainer, styles.contentContainer_layout)}>
                <div className={clsx(styles.block2, styles.block2_layout)}>
                  <h5 className={clsx(styles.highlights2_box, styles.highlights2_box_layout)}>
                    <pre className={clsx(styles.highlights2)}>
                      {notice.description}
                    </pre>
                  </h5>
                </div>
              </div>
            </div>

            <div className={clsx(styles.btnsContainer, styles.btnsContainer_layout)}>
              <div
                onClick={viewModel.handlerCloseAlert}
                className={clsx(styles.btnsContainer_item)}
              >
                <div className={clsx(styles.cancelBtn, styles.cancelBtn_layout)}>
                  <h5 className={clsx(styles.cancelText, styles.cancelText_layout)}>
                    {i18n.t('btn_cancel')}
                  </h5>
                </div>
              </div>
              <div className={clsx(styles.btnsContainer_spacer)} />
              {
                profile
                  ? (
                    <Link
                      className={clsx(styles.btnsContainer_item)}
                      to={`/purchase/${cid}`}
                      onClick={viewModel.handlerCloseAlert}
                    >
                      <div className={clsx(styles.submitBtn, styles.submitBtn_layout)}>
                        <h5 className={clsx(styles.submitText, styles.submitText_layout)}>
                          {i18n.t('profile_edit_save_confirm')}
                        </h5>
                      </div>
                    </Link>
                  )
                  : (
                    <div
                      className={clsx(styles.btnsContainer_item)}
                      onClick={signInViewModel.handleOpen}
                    >
                      <div className={clsx(styles.submitBtn, styles.submitBtn_layout)}>
                        <h5 className={clsx(styles.submitText, styles.submitText_layout)}>
                          {i18n.t('profile_edit_save_confirm')}
                        </h5>
                      </div>
                    </div>
                  )
              }
            </div>
          </div>
        </div>
      </AlertView>
    );
  }
}

PurchaseModal.propTypes = {
  viewModel: PropTypes.object,
  notice: PropTypes.object,
  profile: PropTypes.object,
  cid: PropTypes.string
};

PurchaseModal.defaultProps = {
  viewModel: {
    didMount: () => { }
  },
  notice: {},
  profile: {},
  cid: ''
};

export default withProfile(withRouter(PurchaseModal), false);
